import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { hideModal } from '../../../../actions/modal';
import { updateExerciseStatus } from '../../../../actions/status';

import Modal from '../..';
import Buttons from '../../buttons';
import { Content, ModalBodyContainer } from '../../components';

export const Message = styled.span``;

export const CleanTextModalBody = ({ application, homework, status, onClose, updateExerciseStatus }) => {
    const onCancel = () => {
        updateExerciseStatus(homework.exercises[status.currentExerciseIndex].id, [], status, application.saveStatus);
        onClose();
    };

    return (
        <Modal title="Vuoi cancellare il testo?" onClose={onClose}>
            <ModalBodyContainer>
                <Content>
                    <Message className="body-3">{'Stai per cancellare tutto il testo che hai inserito in questo campo'}</Message>
                </Content>
                <Buttons
                    primaryButtonClick={onCancel}
                    primaryButtonText="Cancella"
                    tertiaryButtonClick={onClose}
                    tertiaryButtonText="Non cancellare"
                />
            </ModalBodyContainer>
        </Modal>
    );
};

CleanTextModalBody.propTypes = {
    application: PropTypes.object,
    homework: PropTypes.object,
    status: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    updateExerciseStatus: PropTypes.func.isRequired,
};

const actionsCreator = {
    onClose: hideModal,
    updateExerciseStatus,
};

const mapStateToProps = (state) => {
    return {
        application: state.application,
        homework: state.homework,
        status: state.status,
    };
};

export default connect(mapStateToProps, actionsCreator)(CleanTextModalBody);
